import React, { forwardRef } from "react";
import { Form } from "react-bootstrap";

export interface TextInputProps
  extends Omit<React.ComponentProps<typeof Form.Control>, "ref"> {
  label?: string;
  isRequired?: boolean;
  groupProps?: React.ComponentProps<typeof Form.Group>;
  labelProps?: React.ComponentProps<typeof Form.Label>;
  error?: string;
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      label,
      isRequired = false,
      groupProps = {},
      labelProps = {},
      error,
      ...controlProps
    },
    ref
  ) => {
    const { controlId, ...otherGroupProps } = groupProps;
    return (
      <>
        <Form.Group controlId={controlId} {...otherGroupProps}>
          {label && (
            <Form.Label {...labelProps}>
              {label} {isRequired && <span style={{ color: "red" }}>*</span>}
            </Form.Label>
          )}

          <Form.Control ref={ref} {...controlProps} />
          {error && (
            <span
              style={{ height: "20px", fontSize: "13px" }}
              className="text-danger mt-1"
            >
              {error}
            </span>
          )}
        </Form.Group>
      </>
    );
  }
);

TextInput.displayName = "TextInput";
export default TextInput;
